export const HomeSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 19"
    aria-hidden="true"
    role="presentation"
    width={24}
    height={24}
  >
    <path
      d="M17.23,19.13v-8.5a.87.87,0,0,0-1.74,0v7.63H12.77V13.61a1.15,1.15,0,0,0-1.15-1.15H8.38a1.15,1.15,0,0,0-1.15,1.15v4.65H4.51V10.63a.87.87,0,0,0-1.74,0v8.5a.87.87,0,0,0,.87.87H8.1A.87.87,0,0,0,9,19.13V14.2H11v4.93a.87.87,0,0,0,.87.87h4.46A.87.87,0,0,0,17.23,19.13Zm1.9-8.48a.89.89,0,0,1-.61-.24L10,2.08,1.48,10.41A.87.87,0,0,1,.26,9.16L9.39.25a.88.88,0,0,1,1.22,0l9.13,8.91a.87.87,0,0,1,0,1.23A.83.83,0,0,1,19.13,10.65Z"
      fillRule="evenodd"
    />
  </svg>
)
export default HomeSvg
